import React, { Fragment } from 'react';
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import { Link } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import HomeIcon from "@material-ui/core/SvgIcon/SvgIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { createStyles, makeStyles } from "@material-ui/core";
import LogoutIcon from '@material-ui/icons/Clear';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        toolbar: theme.mixins.toolbar,
    });
});
export function MenuDrawer(_a) {
    var logout = _a.logout, logoArea = _a.logoArea, routerLinks = _a.routerLinks;
    var classes = useStyles();
    return (React.createElement(Fragment, null,
        React.createElement("div", { className: classes.toolbar }),
        React.createElement(Divider, null),
        logoArea,
        logoArea ? React.createElement(Divider, null) : null,
        React.createElement(List, null,
            React.createElement(Link, { to: "/", style: { textDecoration: 'none' } },
                React.createElement(ListItem, { button: true, key: "Home" },
                    React.createElement(ListItemIcon, null,
                        React.createElement(HomeIcon, null)),
                    React.createElement(ListItemText, { primary: "Home" }))),
            routerLinks),
        React.createElement(Divider, null),
        React.createElement(List, null,
            React.createElement(ListItem, { button: true, key: "Consumer", component: "a", href: "https://consumer-janitza-cloud.firebaseapp.com" },
                React.createElement(ListItemIcon, null,
                    React.createElement(HomeIcon, null)),
                React.createElement(ListItemText, { primary: "Consumer" })),
            React.createElement(ListItem, { button: true, key: "Devices", component: "a", href: "https://devices.beta.janitza.cloud" },
                React.createElement(ListItemIcon, null,
                    React.createElement(HomeIcon, null)),
                React.createElement(ListItemText, { primary: "Devices" })),
            React.createElement(ListItem, { button: true, key: "Hub", component: "a", href: "https://hubs.beta.janitza.cloud" },
                React.createElement(ListItemIcon, null,
                    React.createElement(HomeIcon, null)),
                React.createElement(ListItemText, { primary: "Hub" }))),
        React.createElement(Divider, null),
        React.createElement(List, null,
            React.createElement(ListItem, { button: true, key: "Logout", onClick: logout },
                React.createElement(ListItemIcon, null,
                    React.createElement(LogoutIcon, null)),
                React.createElement(ListItemText, { primary: "Logout" })))));
}
//# sourceMappingURL=MenuDrawer.js.map